<template>
  <section class="container">
    <div class="management_top_box mb-3">
      <h4>{{ $t("management.contactClsRegister") }}</h4>
    </div>
    <div class="brick_box">
      <table class="write_tbl responsive_tbl">
        <tbody>
          <tr>
            <th>{{ $t("common.ClassificationName") }}</th>
            <td>
              <input
                type="text"
                name="className"
                v-model="cls.className"
                class="int_type01"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.clsDetail") }}</th>
            <td>
              <textarea
                name="classDesc"
                v-model="cls.classDesc"
                class="textarea_type"
                rows="10"
                v-validate="'required'"
              >
              </textarea>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <router-link
          to="/management/support/contact"
          class="btn btn-outline-dark btn-lg m-1"
          >{{ $t("common.list") }}</router-link
        >
        <button @click="saveContactCls" class="btn btn-primary btn-lg m-1">
          {{ $t("common.save") }}
        </button>
        <button
          v-if="cls.crudType == 'U'"
          @click="deleteContactCls"
          class="btn btn-secondary btn-lg m-1"
        >
          {{ $t("common.delete") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { saveContactCls, getContact, deleteContactCls } from "@/api/contact";
export default {
  data() {
    return {
      cls: { classId: "", crudType: "I" },
      classId: "",
    };
  },
  mounted() {
    if (this.$route.params.classId != null) {
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.cls.classId = this.$route.params.classId;
        const { data } = await getContact(this.cls);
        this.cls = data.cls;
        console.log(this.cls);
        if (this.cls != null) {
          this.cls.crudType = "U";
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 저장/ 수정
    async saveContactCls() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        const { data } = await saveContactCls(this.cls);
        if (data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          this.$router.push({ name: "mgmtContact" });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteContactCls() {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          const { data } = await deleteContactCls(this.cls);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.$router.push({ name: "mgmtContact" });
          } else {
            console.log("성공");
            alert(this.$t("alert.ErrorPleasecontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style></style>
